module.exports = __webpack_public_path__ + "static/media/21.a1036f6e.jpg";